module.exports = __webpack_public_path__ + "static/media/b2b.5c7beee3.svg";